<template>
    <Card>
        <div>
            <div class="multiple">
                <div class="child-div">选择年份</div>
                <DatePicker  :value="timePeriodDate" @on-change="timePeriodDateChange"
                            type="year"
                            placeholder="选择日期" style="width: 150px"></DatePicker>
                <Button class='ivu-btn-circle' style="margin-left: 20px" type="primary" @click="getList">搜索</Button>
            </div>

            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">

                </Table>
            </div>
        </div>
    </Card>
</template>
<script>
    import {getEarningsStatement} from "../../api/finance";
    import {mapGetters} from "vuex";

    export default {
        name: "earningsStatement",
        components: {},

        data() {
            return {
                timePeriod: '0',
                timePeriodDate: '',
                datas: [
                ],
                columns: [
                    {
                        "title": "月份",
                        "key": "month"
                    },
                    {
                        "title": "数据成本",
                        "key": "data_cost"
                    },
                    {
                        "title": "工资成本",
                        "key": "salary_cost"
                    },
                    {
                        "title": "其他支出",
                        "key": "other_cost"
                    },
                    {
                        "title": "渠道成本",
                        "key": "channel_cost"
                    },
                    {
                        "title": "业绩创收",
                        "key": "achievement"
                    },
                    {
                        "title": "利润",
                        "key": "profit"
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.loadData();
            this.getList();
        },
        methods: {
            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            async loadData() {
            },
            changePage(e) {
                this.page = e;
                this.getList();
            },
            async getList() {
                let that = this;
                let data = {
                    token: that.token,
                    timePeriod: that.timePeriod,
                    timePeriodDate: that.timePeriodDate,
                };
                let res = await getEarningsStatement(that, data);
                if (res.code == 1) {
                    that.datas = res.data.list;
                }
            },
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .inline-block{
        display: inline-block;
    }
</style>
